import React, { Component } from "react";
import data from "currency-codes/data";

import ManageMerchantGatewayRatesTable from "./ManageMerchantGatewayRatesTable";
import ManageMerchantStripeRatesTable from "./ManageMerchantStripeRatesTable";

class ManageMerchantGatewayRates extends Component {
	constructor(props) {
		super(props);

		this.state = {
			baseRate: props.baseRate,
			rates: props.rates,
			gatewayCurrency: this.getGatewayCurrency(props.rates, props.gateway),
		};
	}

	componentDidUpdate(prevProps) {
		if (
			JSON.stringify(prevProps.baseRate) !== JSON.stringify(this.props.baseRate)
		)
			this.setState({ baseRate: this.props.baseRate });

		if (JSON.stringify(prevProps.rates) !== JSON.stringify(this.props.rates)) {
			this.setState({
				rates: this.props.rates,
				gatewayCurrency: this.getGatewayCurrency(
					this.props.rates,
					this.props.gateway
				),
			});
		}
	}

	getGatewayCurrency = (rates, gateway) => {
		let gatewayCurrency = [];
		if (gateway !== "stripe") {
			if (rates[gateway]) {
				let codes = Object.keys(rates[gateway]);
				if (codes.length > 0) {
					for (let code of codes) {
						let target = data.find((i) => i.number === String(code));
						gatewayCurrency.push({ code: parseInt(code), name: target.code });
					}
				}
			}
		}
		return gatewayCurrency;
	};

	render() {
		const { merchant, MDRTypes, gateway, retrieveMerchants, readOnly } =
			this.props;
		const { baseRate, rates, gatewayCurrency } = this.state;

		if (gateway !== "stripe")
			return (
				<div className="uk-flex">
					<div className="uk-width-1-6 uk-padding-small uk-padding-remove-horizontal uk-margin-small-top uk-margin-right">
						<ul
							className="uk-tab-left"
							uk-tab={`connect: #manage-${gateway}-currency-rates`}
						>
							{gatewayCurrency.map((currency, index) => (
								<li
									key={`manage-${gateway}-${currency.name}`}
									className={`${index === 0 ? "uk-active" : ""}`}
								>
									<a href="#">{currency.name}</a>
								</li>
							))}
						</ul>
					</div>
					<div className="uk-width-5-6 uk-padding-small uk-padding-remove-vertical">
						<ul id={`manage-${gateway}-currency-rates`} className="uk-switcher">
							{gatewayCurrency.map((currency) => (
								<li key={`manage-${gateway}-${currency.name}-rates`}>
									<ManageMerchantGatewayRatesTable
										merchant={merchant}
										MDRTypes={MDRTypes}
										baseRate={baseRate[gateway]}
										rates={rates[gateway]}
										gateway={gateway}
										currency={currency.code}
										retrieveMerchants={retrieveMerchants}
										readOnly={readOnly}
									/>
								</li>
							))}
						</ul>
					</div>
				</div>
			);

		return (
			<ManageMerchantStripeRatesTable
				merchant={merchant}
				MDRTypes={MDRTypes}
				baseRate={baseRate[gateway]}
				rates={rates[gateway]}
				gateway={gateway}
				retrieveMerchants={retrieveMerchants}
				readOnly={readOnly}
			/>
		);
	}
}

export default ManageMerchantGatewayRates;
